'use client';
import { useState } from 'react';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import UserNav from './UserNav';
import Footer from './Footer';
import { ModalProvider } from '@/components/ModalProvider';

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  return (
    <ModalProvider>
      <div className="min-h-screen bg-[#050505] text-white">
        <Sidebar 
          isCollapsed={isCollapsed} 
          toggleSidebar={() => setIsCollapsed(!isCollapsed)}
          isMobileOpen={isMobileOpen}
          closeMobile={() => setIsMobileOpen(false)}
        />
        <button 
          onClick={() => setIsMobileOpen(true)}
          className="md:hidden fixed top-4 left-4 z-50 p-2 bg-[#1f1f1f] rounded-lg border border-[#333] text-zinc-400 hover:text-white transition-colors"
        >
          <Menu size={24} />
        </button>
        <main 
          className={`
            relative min-h-screen flex flex-col
            transition-all duration-300 ease-[cubic-bezier(0.2,0,0,1)]
            ml-0 
            ${isCollapsed ? 'md:ml-[80px]' : 'md:ml-[280px]'}
          `}
        >
          <div className="absolute top-6 right-6 z-40">
             <UserNav />
          </div>
          <div className="flex-1">
             {children}
          </div>
          <Footer />
        </main>
      </div>
    </ModalProvider>
  );
}
